const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function shopChat(payload) {
  try {
    const r = await fetch(`${API}/shop/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!r.ok) return null;
    return await r.json();
  } catch {
    return null;
  }
}

export async function shopTryon(productId, photo) {
  const r = await fetch(`${API}/shop/tryon`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product_id: productId, photo }),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "এবার সাজানো গেল না — একটু পরে আবার চেষ্টা করুন");
  return d.url;
}

export async function shopOrder(payload) {
  const r = await fetch(`${API}/shop/order`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "রসিদ তৈরি হলো না");
  return d;
}

export async function repVoice(text) {
  try {
    const r = await fetch(`${API}/host/voice?voice=rep`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text }),
    });
    if (!r.ok) return null;
    return await r.blob();
  } catch {
    return null;
  }
}

export const imgSrc = (u) => (!u || u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);
